import { SubscriptionPlan } from '@modules-deprecated/app/organization/enums/subscriptionPlan'

import { subscriptionPlansCatalog } from './constants/subscriptionPlansCatalog'
import { resolveSubscriptionPlan } from './utils/resolveSubscriptionPlan'

type BehaviorBooleanFlag = 'hasLimits' | 'isFree' | 'noCoupons' | 'noPeriodSelection'

const filterCatalogByBehavior = (flag: BehaviorBooleanFlag): SubscriptionPlan[] =>
  (Object.keys(subscriptionPlansCatalog) as SubscriptionPlan[]).filter(
    (plan) => resolveSubscriptionPlan(plan).behavior?.[flag] ?? false,
  )

export const freePlans = filterCatalogByBehavior('isFree')
export const plansWithLimits = filterCatalogByBehavior('hasLimits')
export const plansWithoutCoupons = filterCatalogByBehavior('noCoupons')
export const plansWithNoPeriodSelection = filterCatalogByBehavior('noPeriodSelection')

export const plansPossibleToChange = [
  SubscriptionPlan.AgerasFree,
  SubscriptionPlan.Basic,
  SubscriptionPlan.BasicPaid,
  SubscriptionPlan.Free,
  SubscriptionPlan.Start,
  SubscriptionPlan.Plus,
  SubscriptionPlan.Premium,
  SubscriptionPlan.Pro,
]

export const isPaidPlan = (plan: SubscriptionPlan) => !freePlans.includes(plan)
